import { Crown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSubscription } from '../../hooks/useSubscription';

export function SubscriptionBanner() {
  const { isPremium } = useSubscription();

  if (isPremium) return null;

  return (
    <div className="bg-gradient-to-r from-amber-100 to-amber-50 dark:from-amber-900/30 dark:to-amber-800/30 p-4 rounded-lg mb-6">
      <div className="flex items-center gap-3">
        <Crown className="h-5 w-5 text-amber-600 dark:text-amber-500" />
        <div className="flex-1">
          <p className="text-amber-800 dark:text-amber-200">
            Upgrade to Premium to unlock custom domains, themes, and more!
          </p>
        </div>
        <Link 
          to="/pricing"
          className="btn-primary bg-amber-600 hover:bg-amber-700 border-amber-600 hover:border-amber-700"
        >
          Upgrade Now
        </Link>
      </div>
    </div>
  );
}